import { renderPrincipal } from '../../../../components/tables/table-column-renderers'
import { sortBooleanColumn, sortNumericColumn, sortStringColumn } from '../../../../components/tables/utils'
import { renderIsCompliant } from '../IsCompliant'

export const buildShortAndLongCompliancesColumns = [
  {
    title: 'Rating',
    dataIndex: 'rating',
    sorter: sortStringColumn({ dataIndex: 'rating' }),
  },
  {
    title: 'Is Compliant',
    dataIndex: 'isCompliant',
    render: renderIsCompliant,
    sorter: sortBooleanColumn({ dataIndex: 'isCompliant' }),
  },
  {
    title: 'Trades',
    dataIndex: 'tradesCount',
    sorter: sortNumericColumn({ dataIndex: 'tradesCount' }),
  },
  {
    title: 'Invested ($)',
    dataIndex: 'amountInvested',
    render: renderPrincipal,
    sorter: sortNumericColumn({ dataIndex: 'amountInvested' }),
  },
  {
    title: 'Available ($)',
    dataIndex: 'amountAvailable',
    render: renderPrincipal,
    sorter: sortNumericColumn({ dataIndex: 'amountAvailable' }),
  },
  { title: 'Max (%)', dataIndex: 'maxLimitPct', sorter: sortNumericColumn({ dataIndex: 'maxLimitPct' }) },
  {
    title: 'Shared (%)',
    dataIndex: 'investmentSharePct',
    sorter: sortNumericColumn({ dataIndex: 'investmentSharePct' }),
  },
]
